// Reusable dashboard Ideas panel extracted from the former Idea Bank page.
// Retains Archive and per-social workflow actions, with optional
// aggregate counts/pagination. Parents own scoped loading and archive writes.
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import PromotionSectionCard from "./promotion_section_card";
import { PROMOTION_ENABLED_PLATFORM_OPTIONS } from "../constants/promotion_platforms";
import { PROMOTION_WORKFLOW_BADGE_CLASSES, getPromotionWorkflowLabel, getPromotionWorkflowState } from "../helpers/promotion_workflow";

export default function Ideas({ ideas, promotionUrl, postsByIdeaAndPlatform = {}, loading = false, saving = false,
  socialFilter = "all", onArchive, totalCount = ideas.length, error = "", onRetry,
  emptyMessage = "No ideas match the selected filters.", children }) {
  const navigate = useNavigate();
  const openSocialDraft = (idea, platform) => {
    const post = postsByIdeaAndPlatform[`${idea.id}:${platform}`];
    navigate(post
      ? `${promotionUrl("promotion_studio")}?post=${encodeURIComponent(post.id)}`
      : `${promotionUrl("promotion_studio")}?idea=${encodeURIComponent(idea.id)}&platform=${encodeURIComponent(platform)}`);
  };
  return <PromotionSectionCard title={`Ideas (${totalCount})`} icon="bi bi-lightbulb-fill">
    {loading && <p role="status">Loading ideas...</p>}
    {!loading && error && <div>
      <p className="text-danger">Unable to load ideas.</p>
      {onRetry && <button type="button" className="btn btn-outline-primary" onClick={onRetry}>Retry</button>}
    </div>}
    {!loading && !error && ideas.length === 0 && <p className="text-muted mb-0">{emptyMessage}</p>}
    {!loading && !error && ideas.map((idea) => <article key={idea.id} className="border rounded p-3 mb-3" aria-label={idea.title || "Untitled Idea"}>
      <div className="d-flex justify-content-between align-items-start gap-3">
        <h5 className="mb-2"><Link to={`${promotionUrl("promotion_studio")}?idea=${encodeURIComponent(idea.id)}`}>{idea.title || "Untitled Idea"}</Link></h5>
        <button type="button" className="btn btn-sm btn-outline-secondary" disabled={saving || idea.ideaStatus === "archived"}
          onClick={() => onArchive(idea)}>{idea.ideaStatus === "archived" ? "Archived" : "Archive"}</button>
      </div>
      {idea.description && <p className="text-muted mb-2">{idea.description}</p>}
      {typeof idea.draftCount === "number" && <p className="small text-muted mb-2">Drafts: {idea.draftCount} · Promotions: {idea.promotionCount || 0}</p>}
      <div className="d-flex flex-wrap gap-2 mt-3">
        {PROMOTION_ENABLED_PLATFORM_OPTIONS.filter((option) => socialFilter === "all" || option.value === socialFilter).map((option) => {
          const post = postsByIdeaAndPlatform[`${idea.id}:${option.value}`];
          const state = getPromotionWorkflowState(post);
          return <button key={option.value} type="button" className={`badge border-0 py-2 px-3 ${PROMOTION_WORKFLOW_BADGE_CLASSES[state]}`}
            onClick={() => openSocialDraft(idea, option.value)} title={post ? "Open this social post" : "Create this social post"}>
            {option.label}: {getPromotionWorkflowLabel(post)}
          </button>;
        })}
      </div>
    </article>)}
    {!loading && !error && children}
  </PromotionSectionCard>;
}
